// API 환경 설정
const isDevelopment = process.env.NODE_ENV === "development";
// const isDevelopment = false; //
// 현재 환경 정보 출력 (개발 시 확인용)
console.log(
  `현재 API 환경: ${isDevelopment ? "개발(Development)" : "배포(Production)"}`,
);

// API 기본 URL
const BASE_API_URL = isDevelopment
  ? "https://dev-be.aptconcierge.ai/api"
  : "https://prod-be.aptconcierge.ai/api";

// Auth 서비스 URL
const AUTH_API_URL = "https://admin.aptconcierge.ai";

// CloudFront URL - 환경변수 또는 설정에서 가져오는 것이 좋습니다
const CLOUDFRONT_URL =
  process.env.REACT_APP_CLOUDFRONT_URL ||
  "https://dr2sual6txf71.cloudfront.net";

// S3 도메인 패턴 (정규식)
const S3_DOMAIN_PATTERN =
  /https:\/\/s3\.ap-northeast-2\.amazonaws\.com\/dev\.proh\//;

// 쿠키 관련 설정
const COOKIE_CONFIG = {
  // 쿠키 키 이름
  KEYS: {
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    USER_INFO: "user_info",
  },

  // 쿠키 만료 시간 (일 단위)
  EXPIRES: {
    ACCESS_TOKEN: 1, // 1일
    REFRESH_TOKEN: 30, // 30일
    USER_INFO: 7, // 7일
  },

  // 쿠키 옵션
  OPTIONS: {
    path: "/",
    secure: !isDevelopment, // 개발 환경에서는 false, 배포 환경에서는 true
    sameSite: "strict",
  },
};

// S3 URL을 CloudFront URL로 변환하는 유틸리티 함수
const convertToCloudFrontUrl = (url) => {
  if (!url) return url;
  // S3 URL을 CloudFront URL로 변환
  return url.replace(S3_DOMAIN_PATTERN, `${CLOUDFRONT_URL}/`);
};

// S3 URL에서 상대 경로만 추출하는 유틸리티 함수
const extractRelativePath = (url) => {
  if (!url) return url;
  // S3 URL에서 상대 경로 추출 (images/origin/...)
  const match = url.match(/images\/origin\/.*$/);
  return match ? match[0] : url;
};

// 각 API 엔드포인트
const API_ENDPOINTS = {
  // 현재 환경 (개발/배포)
  IS_DEVELOPMENT: isDevelopment,

  // 기본 URL (다른 곳에서 필요할 경우)
  BASE_URL: BASE_API_URL,
  AUTH_URL: AUTH_API_URL,
  CLOUDFRONT_URL: CLOUDFRONT_URL,

  // 유틸리티 함수
  convertToCloudFrontUrl,
  extractRelativePath,

  // 쿠키 설정
  COOKIE_CONFIG,

  // 사용자 정보 조회
  USER_INFO: `${BASE_API_URL}/mobile/user`,

  // 토큰 갱신
  REFRESH_TOKEN: `${AUTH_API_URL}/api/auth/refresh`,

  // 하자 점검 관련 API
  SUBMIT_INSPECTION: `${BASE_API_URL}/api/mobile/submit-inspection`,
  GET_INSPECTIONS: `${BASE_API_URL}/api/mobile/inspections`,
  GET_INSPECTION_DETAIL: (id) => `${BASE_API_URL}/api/mobile/inspections/${id}`,

  // 기타 API 엔드포인트들 추가 가능
};

export default API_ENDPOINTS;
